import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRDocumentGlobalPartnerId = createSelector(
  [selectQbrState],
  (state) => state.globalPartnerId
)
